import { ConfigurationGroupOptionType } from 'shared-types/SpaPackage';

export const adaptExtras = (extras) => {
  const allOptions = extras.map((e) => e.options);
  return ([] as ConfigurationGroupOptionType[]).concat(...allOptions).sort((a, b) => {
    if (!a.featured && b.featured) {
      return 1;
    }
    if (a.featured && !b.featured) {
      return -1;
    }
    return 0;
  });
};
